import React from 'react';
import { BsArrowLeft } from "react-icons/bs";
import { useNavigate } from 'react-router-dom';  // Updated import
import ProfileImageView from '../ProfileImageView';
import { useAppSelector } from 'src/app/services/store';
import { getCurrentChild, getShowDownloadAppBanner } from 'src/shared/redux-state/src';
import { BiSolidPencil, BiDownload } from "react-icons/bi";
import CustomButton from '../CustomButton';
import DownloadAppBanner from '../DownloadAppBanner';
import { usePreviousRoute } from 'src/app/guards/PreviousRouteContext';
import { AppRoutes } from 'src/app/navigation/routes';
import { PiPrinterFill } from "react-icons/pi";


type ProfileHeaderProps = {
  onEditClick?: () => void;
  title?: string;
  isEditable?: boolean;
  showProfileImage?: boolean;
  showDownloadBtn?: boolean,
  handleDownload?: () => void,
  isPrintPage?: boolean;
  handlePrint?: () => void;
}

const ProfileHeader: React.FC<ProfileHeaderProps> = ({ onEditClick, title, isEditable = false, showProfileImage = true, showDownloadBtn = false, handleDownload, isPrintPage = false, handlePrint }) => {
  const navigate = useNavigate();
  const {previousRoute} = usePreviousRoute();
  const currentChild = useAppSelector(getCurrentChild);
  const showDownloadAppBanner = useAppSelector(getShowDownloadAppBanner);

  return (
    <div className={`header ${showDownloadAppBanner ? 'h-auto' : ''}`}>
      {showDownloadAppBanner ? <DownloadAppBanner /> : null}
      <div className='container h-100'>
        <div className='row align-items-center h-100 justify-content-between'>
          <div className='col-2'>
            <CustomButton icon={<BsArrowLeft size={24} />} color="link" 
              onClick={() => {
                if (!previousRoute || previousRoute === AppRoutes.UNSUBSCRIBE_EMAILS || (previousRoute && previousRoute.includes('deep-link'))){ 
                  navigate(AppRoutes.HOME) 
                }
                else navigate(-1)
              }} 
              customBtnStyle='custom-btn-icon' 
            />
          </div>
          {title && <div className='col-8 text-center'>
            <div className='fs-6 fw-semibold text-black mb-0 text-truncate'>{title} <span className='ms-1 child-name-print'>({currentChild.name})</span></div>
          </div>}
          <div className='col-2'>
            <div className='d-flex align-items-center justify-content-end gap-2'>
              {isPrintPage && <CustomButton icon={<PiPrinterFill size={22} />} color="link" onClick={handlePrint} customBtnStyle='custom-btn-icon' /> }
              {((isEditable && onEditClick) || showDownloadBtn || showProfileImage) && <div className='d-flex align-items-center justify-content-end gap-3'>
                {isEditable && onEditClick ? 
                  <div className='d-inline-flex align-items-center justify-content-center'>
                    <CustomButton icon={<BiSolidPencil size={20} />} color="link" onClick={onEditClick} customBtnStyle='custom-btn-icon' />
                  </div>
                : null}
                
                {showDownloadBtn ? <div className='d-inline-flex align-items-center justify-content-center'>
                  <CustomButton icon={<BiDownload size={25} />} color="link" onClick={handleDownload} customBtnStyle='custom-btn-icon' />
                </div> : null}
                {showProfileImage && <div>
                  <ProfileImageView
                    name={currentChild?.name}
                    imageUrl={currentChild?.photo}
                  />
                </div>}
              </div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;